export default function (el) {
	$(document).on('click', '.sl-brindes-page', function() {
		var pagina = $(this).data('pagina');
		$('.loader').show();
		$.post(wp.ajax_url, {
			action: 'sl_brindes',
			pagina: pagina,
			params: $('input[name="params"]').val()
		}, function(response) {
			document.querySelector('[data-component="vc_sl_brindes"]').outerHTML = response;
			$('.loader').hide();
		});
	});
}